import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'
import useSettingsManager from '../hooks/use-settings-manager'
import PortModalItem from './PortModalItem'
import PortIterator from '../PortIterator'
import SVGIcon from '../helpers/icons'

function PortModal (props) {

  const manager = usePortManager()
  const settings_manager = useSettingsManager()

  if (!manager.portModalIsOpen) return null

  return (
    <>
      <div className="port-modal-background" onClick={() => manager.closePortModal()}/>
      <aside className={'port-modal'}>
        <header>
          <h3>{manager.currentPort.name}</h3>
          <p>
            {
              settings_manager.getOtherSettings(
                'active_port',
                'Aktiv port'
              )
            }</p>
        </header>
        <ul>
          <PortIterator>
            <PortModalItem/>
          </PortIterator>
        </ul>
        <footer>
          <div className={'add-item'} onClick={() => manager.addPort()}>
            <figure className={'add'}><SVGIcon type={'add'} className={'port-modal-icon'}/></figure>
            {
              settings_manager.getOtherSettings(
                'add_port',
                'Tilføj Port'
              )
            }
          </div>
        </footer>
      </aside>
    </>
  )
}

export default observer(PortModal)